export const LOCAL_STORAGE_PERMISSIONS = 'permissions'
